module.exports = __webpack_public_path__ + "5ce610992fd91a64dc8cfefe9488f03c.pdf";